import Link from 'next/link';
import ViewButton from "./buttons/ViewButton";
import {DateTime} from "luxon";
import {SvgEventTicketSm} from "/components/shared/SvgIcons";

export default function NextShowItem({title, slug, time, url=null, subtitle=null}) {
    console.log('url', url);
    return (
        <div className="flex flex-1 flex-col lg:flex-row flex-wrap text-sm xl:text-base justify-start py-1 flex-start">
          <div className="flex-1 flex flex-row items-start">
            <div className="">{time && DateTime.fromISO(time).toFormat("HH:mm")}</div>
            <div className='mx-1'>-</div>
            <div>
              <div className="leading-6 xl:leading-8 font-cooper-hewitt-bold max-w-[50vw] md:max-w-auto capitalize truncate">
                {url ? (
                    <Link href={url} >
                      <a>
                        {title}
                      </a>
                    </Link>
                ) : title}
              </div>
              {subtitle && <div className="-mt-1 text-sm max-w-70">{subtitle}</div>}
            </div>
          </div>
          <div>
            <ViewButton href={`/tickets/${slug}`} className='px-2 2xl:px-4 pt-2 pb-1 h-7 2xl:ml-12'
                        icon={<div className='mr-2 mb-1'>{SvgEventTicketSm()}</div>}>
              tickets
            </ViewButton>
          </div>
        </div>
    );
}
